import React from "react";
import "./Footer.css";
import { Link } from "react-router-dom";

const Footer: React.FC = () => {
  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  return (
    <footer>
      <div className="back-to-top" onClick={scrollToTop}>
        <div className="up-arrow"></div>
      </div>

      <div className="footer-content">
        <div className="social-links">
          <a
            href="https://www.tiktok.com/@y.chibs"
            aria-label="TikTok"
            className="social-icon"
          >
            <i className="fab fa-tiktok"></i>
          </a>
          <a
            href="https://www.linkedin.com/in/chibike-nwangwu-509b35179/"
            aria-label="LinkedIn"
            className="social-icon"
          >
            <i className="fab fa-linkedin-in"></i>
          </a>
          <a
            href="https://instagram.com/y.chibs"
            aria-label="Instagram"
            className="social-icon"
          >
            <i className="fab fa-instagram"></i>
          </a>
          <a
            href="https://www.youtube.com/@chibsolympia9548"
            aria-label="YouTube"
            className="social-icon"
          >
            <i className="fab fa-youtube"></i>
          </a>
        </div>

        <div className="copyright">
          © 2025 Chibs Olympia. All Rights Reserved.
          <br />
          <div className="footer-links">
            <Link to="/terms-of-service">Terms of Service</Link>
            <Link to="/privacy-policy">Privacy Policy</Link>
            <a href="mailto:olympiaacademy@chibsolympia.com">Contact</a>
          </div>
          <br />
          <span className="disclaimer">
            Results may vary. This program is not intended to diagnose, treat,
            cure, or prevent any disease.
          </span>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
